import axios, { AxiosInstance, AxiosRequestHeaders } from 'axios';
import { FirebaseAuth } from '../FirebaseService/auth';
import { instrumentAxios } from '../shared/honeycomb/axiosHoneyCombTelemetry';

export type ClaimScoreApiServiceError = {
  message: string;
  status: number;
  response: {
    data: {
      errors: {
        message: string;
      }[];
    };
  };
};

const baseURL = import.meta.env.VITE_CLAIMSCORE_API_URL;

export const getAuthorizationToken = async (): Promise<string> => {
  const authorizationToken = await FirebaseAuth.getAuthToken();

  return `Bearer ${authorizationToken}`;
};

const claimScoreApiServiceClient: AxiosInstance = axios.create({
  baseURL,
});

instrumentAxios(claimScoreApiServiceClient, {
  tracerName: 'claimscore-api-service',
});

claimScoreApiServiceClient.interceptors.request.use(
  async (config) => {
    const token = await getAuthorizationToken();

    config.headers ??= {} as AxiosRequestHeaders;
    config.headers.Authorization = `${token}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default claimScoreApiServiceClient;
